import { combineReducers } from "redux";
import c from "./constant";
import { Map, List } from "immutable";
import dateFilter from "./DateFilter/reducer";

function filter(state = Map(), action) {
  switch (action.type) {
    case c.REGISTER:
      return state.set(action.dataName, action.filter);
    case c.UNREGISTER:
      return state.remove(action.dataName);
    case c.SET_FILTER:
      return state.set(action.dataName, action.filter);
    case c.RESET:
      return Map();
    default:
      return state;
  }
}

function sortBy(state = Map(), action) {
  switch (action.type) {
    case c.REGISTER:
      return state.set(action.dataName, action.sortBy);
    case c.UNREGISTER:
      return state.remove(action.dataName);
    case c.SET_SORT_BY:
      return state.set(action.dataName, action.sortBy);
    case c.RESET:
      return state.set(action.dataName, null);
    default:
      return state;
  }
}

function sortDirection(state = Map(), action) {
  switch (action.type) {
    case c.REGISTER:
      return state.set(action.dataName, action.sortDirection);
    case c.UNREGISTER:
      return state.remove(action.dataName);
    case c.SET_SORT_DIRECTION:
      return state.set(action.dataName, action.direction);
    case c.RESET:
      return Map();
    default:
      return state;
  }
}

function crumb(state = Map(), action) {
  switch (action.type) {
    case c.REGISTER:
      return state.set(action.dataName, "");
    case c.SET_CRUMB:
      return state.set(action.dataName, action.crumb);
    case c.UNREGISTER:
      return state.remove(action.dataName);
    default:
      return state;
  }
}

// function cursors(state = Map(), action) {
//   switch (action.type) {
//     case c.REGISTER:
//       return state.set(action.dataName, []);
//     case c.SET_CURSOR:
//       return state.set(action.dataName, [action.cursor]);
//     case c.ADD_CURSOR:
//       return state.set(action.dataName, [...state.get(action.dataName), action.cursor]);
//     case c.CLEAR_CURSORS:
//       return state.set(action.dataName, []);
//     case c.UNREGISTER:
//       return state.remove(action.dataName);
//     default:
//       return state;
//   }
// }

export default combineReducers({ sortDirection, filter, sortBy, dateFilter, crumb });
